<template>
  <v-footer fixed v-show="totalIngressos > 0 && mostraCarrinho" class="font-weight-medium blue lighten-4" height="auto" transition="scale-transition" @click.native="expande()">
    <v-expand-transition @click.prevent="expandido">
    <div v-show="expandido">
      <div class="text-h6 black--text" style="margin-top: 10px;">Carrinho</div>
      <div class="text-caption black--text" v-if="$router.history.current.name === 'Passaporte'">Selecione a promoção e escolha quantos ingressos você deseja, logo após clique em adicionar</div>
      <div class="text-caption black--text" v-if="$router.history.current.name !== 'Passaporte'">Clique na forma de pagamento para pagar seu pedido, caso queira mudar algo clique no botão abaixo</div>
      <v-divider class="mt-2 pb-2"></v-divider>
      <div v-for="(itm, i) in carrinho.passaportes" :key="i">
        <div class="float-right text-right" style="padding: 2px 10px 0px 0px">
          <div class="text-caption text--disabled">Qtd {{ itm.quantidade }} Unid</div>
          <div class="font-weight-black">R$ {{ itm.total | fmtNumber }}</div>
        </div>
        <div class="text-subtitle-1 font-weight-black" style="padding-left: 10px; padding-top: 10px;">{{ itm.titulo }}</div>
        <div class="text-caption text--disabled" style="line-height: 12px; padding-left: 10px; padding-bottom: 10px">Bilheteria R$ {{ itm.valorOriginal | fmtNumber }} Site R$ {{ itm.valorPromo | fmtNumber }}</div>
      </div>
    </div>
    </v-expand-transition>
    <span class="mx-auto black--text">{{ totalIngressos }} ingressos - Total: R$ {{ totalCarrinho | fmtNumber }}</span>
    <v-btn v-if="checkBtnComprar()" rounded color="success" right class="no-text-transform" @click="goToPagamento()">Comprar</v-btn>
    <v-btn v-if="$router.history.current.name !== 'Passaporte' && logadoVisitante" rounded color="secondary" right class="no-text-transform" @click="alterarPedido()">Alterar</v-btn>
  </v-footer>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  data: () => ({
    dialog: false,
    expandido: false
  }),
  computed: {
    ...mapState(['carrinho', 'logadoVisitante', 'mostraCarrinho']),
    ...mapGetters(['totalCarrinho', 'totalIngressos'])
  },
  methods: {
    ...mapMutations(['toggleDialogLogin']),
    ...mapActions(['goToPagamento']),
    alterarPedido: function () {
      this.$router.push('/selecione/passaporte')
    },
    expande: function () {
      this.expandido = !this.expandido
    },
    checkBtnComprar: function () {
      return !this.$router.history.current.path.includes('pagamento')
    }
  }
}
</script>
